import { SolutionMap } from "@labs/shared/types/Solution.ts";
import { getTotalElectricityPurchase } from "./getTotalElectricityPurchase.ts";
import { PlanValidationError } from "../../types/PlanValidationError.ts";

export const validatePlan = (
  solutionMap: SolutionMap,
): PlanValidationError[] => {
  const validationErrors: PlanValidationError[] = [];

  const totalElectricityPurchase = getTotalElectricityPurchase(solutionMap);

  if (totalElectricityPurchase > 1) {
    validationErrors.push({
      description: "The total purchased electricity must not exceed 100%.",
      applicableSolutionKeys: ["scope2BuyClean"],
    });
  }

  return validationErrors;
};
